import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { EnumAcaoRecurso } from '../../../../app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from '../../../../app/models/enum/recurso-perfil.enum';
import { IPermissaoModel } from '../../../../app/models/permissao.model';
import { AuthService } from '../../../../app/services/auth.service';
import { BaseListComponent } from "../../../shared/components/base-list/base-list.component";
import { PlanoAcaoService } from '../../../services/plano-acao.service';
import { IPlanoAcaoFiltroModel, IPlanoAcaoModel } from '../../../models/plano-acao-model';
import { PlanoAcaoMonitorAvaliarComponent } from '../plano-acao-monitor-avaliar/plano-acao-monitor-avaliar.component';
import { ModalJustificativaComponent } from '../../../shared/components/modal-justificativa/modal-justificativa.component';
import Swal from 'sweetalert2';
import { PlanoAcaoMonitorMonitorarComponent } from '../plano-acao-monitor-monitorar/plano-acao-monitor-monitorar.component';
import { PlanoAcaoMonitorImprimirComponent } from '../plano-acao-monitor-imprimir/plano-acao-monitor-imprimir.component';
import { PlanoAcaoMonitorImprimirRelatoriaComponent } from '../plano-acao-monitor-imprimir-relatoria/plano-acao-monitor-imprimir-relatoria.component';
import { PlanoAcaoMonitorVersoesComponent } from '../plano-acao-monitor-versoes/plano-acao-monitor-versoes.component';

@Component({
  selector: 'app-plano-acao-monitor-list',
  templateUrl: './plano-acao-monitor-list.component.html',
  styleUrls: ['./plano-acao-monitor-list.component.scss']
})
export class PlanoAcaoMonitorListComponent extends BaseListComponent implements OnInit, AfterViewInit {
  public dataSource = new MatTableDataSource<any>([])
  public selectedModel: any;
  public semDados = false;
  public filtro: IPlanoAcaoFiltroModel = {} as IPlanoAcaoFiltroModel;
  public pageEvent: any;
  public totalItens: number;
  public numeroOsa: string;
  public displayedColumn: string[] = ['id', 'numeroOsa', 'ug', 'referencia', 'tipoAuditoria', 'prazoFinal', 'monitorar', 'status'];
  public situacaoSelecionada: number = 2;
  public permissoes: IPermissaoModel;

  // NOVO: Propriedade para armazenar os filtros aplicados
  private filtrosAtivos: IPlanoAcaoFiltroModel = {} as IPlanoAcaoFiltroModel;

  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild('tabela1') public tabela1: MatSort;

  constructor(
    private PlanoAcaoService: PlanoAcaoService,
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setarPermissoes();

    // NOVO: Escutar mudanças de filtros do componente de filtro
    this.PlanoAcaoService.filtrosAplicados$.subscribe(filtros => {
      if (filtros) 
      {
        this.filtrosAtivos = { ...filtros };
        this.aplicarFiltros();
      }
    });
  }

  private setarPermissoes(): void {

    this.permissoes = new IPermissaoModel();
    this.permissoes.imprimir = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Imprimir);
    this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Visualizar);
    this.permissoes.avaliar = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Avaliar);
    this.permissoes.cancelar = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Cancelar);
    this.permissoes.finalizar = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Finalizar);
    this.permissoes.monitorar = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Monitorar);
    this.permissoes.relatoria = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.Relatoria);
    this.permissoes.finalizarMonitoramento = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.FinalizarMonitoramento);
    this.permissoes.gerarNovaVersao = this.authService.possuiPermissao(EnumRecursoPerfil.Monitoramento, EnumAcaoRecurso.RegistrarVersao);
  }

  ngAfterViewInit() {
    this.configurarFiltro()
    this.obter();
  }

  sortData(sort) {
    this.filtro.colunaOrder = sort.active;
    this.filtro.direcao = sort.direction;
    this.obter();
  }

  public visualizar(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-avaliar";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar",
      visualizar: true,
      id: id,
      podeFinalizar: false
    };

    const modal = this.matDialog.open(PlanoAcaoMonitorAvaliarComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  public monitorar(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-monitorar";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Monitorar",
      visualizar: false,
      id: id
    };

    const modal = this.matDialog.open(PlanoAcaoMonitorMonitorarComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.obter();
      }
    });
  }

  public avaliar(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-avaliar";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Avaliar",
      visualizar: false,
      id: id,
      podeFinalizar: this.permissoes.finalizar
    };

    const modal = this.matDialog.open(PlanoAcaoMonitorAvaliarComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.obter();
      }
    });
  }


  public filtrarPorNumero() {
    this.selectedModel = null;
    var filtro: IPlanoAcaoFiltroModel = { numeroOsa: this.numeroOsa } as IPlanoAcaoFiltroModel;
    this.PlanoAcaoService.obter(filtro);
  }

  public obter(): void {

    this.selectedModel = null;

    this.configurarFiltro(); // Garante que this.filtro está atualizado

    this.PlanoAcaoService.obter(this.filtro).then(() => {
      this.PlanoAcaoService.currentPlanoAcao.subscribe(res => {
        if (res.resultado && res.resultado.length > 0) {
          this.dataSource = new MatTableDataSource<any>(res.resultado);
          this.semDados = false;
        } else {
          this.dataSource = new MatTableDataSource<IPlanoAcaoModel>([]);
          this.semDados = true;
        }

        this.dataSource._updateChangeSubscription();
        this.totalItens = res.totalItens || 0;

        if (this.tabela1) {
          this.dataSource.sort = this.tabela1;
        }
      });
    });
  }

  private configurarFiltro() {
    if (this.paginator) {
      this.filtro.pagina = this.paginator.pageIndex + 1;
      this.filtro.itensPorPagina = this.paginator.pageSize;
    }
  }

  pageChanged(e) {

    if (!this.filtro) {
      this.filtro = {} as IPlanoAcaoFiltroModel;
    }

    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;

    const temFiltroNumeroOsa = this.numeroOsa && this.numeroOsa.toString().trim() !== '';
    const temFiltrosAvancados = this.filtrosAtivos && Object.keys(this.filtrosAtivos).length > 0;

    if (temFiltrosAvancados) {
      const { pagina, itensPorPagina } = this.filtro;
      this.filtro = {
        ...this.filtrosAtivos,
        pagina,
        itensPorPagina
      };
    }

    if (temFiltroNumeroOsa) {
      this.filtro.numeroOsa = this.numeroOsa;
    }

    this.obter();
  }

  public selecionar(item: any) {
		this.selectedModel = !this.selectedModel || this.selectedModel.id !== item.id ? item : null;
  }

  private aplicarFiltros(): void {
    this.filtro = { ...this.filtrosAtivos };
    this.filtro.pagina = 1;
  }

  public imprimir(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-monitor-imprimir";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id
    };
    const modal = this.matDialog.open(
      PlanoAcaoMonitorImprimirComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
    });
  }

  public imprimirRelatoria(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-monitor-imprimir-relatoria";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id
    };
    const modal = this.matDialog.open(
      PlanoAcaoMonitorImprimirRelatoriaComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
    });
  }

  public cancelar(planoAcao: IPlanoAcaoModel) {

    Swal.fire({
      title: "Cancelar Plano de Ação",
      text: "Deseja cancelar o plano de Ação [" + planoAcao.osaExecucao.osa?.numero + "] - [" + planoAcao?.unidadeGestora?.sigla + "] ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {

        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-component';
        dialogConfig.width = '45vw';
        dialogConfig.maxHeight = '85vh';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = false;
        dialogConfig.data = {
        }
        const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
        modal.afterClosed().subscribe(justificativa => {

          if (justificativa) {

            planoAcao.responsavelIdCanc = this.authService.usuario.id; 
            planoAcao.justificativaCanc = justificativa; 

            this.PlanoAcaoService.cancelar(planoAcao)
              .then((res) => {
                if (res.sucesso) {
                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    text: res.mensagem.descricao,
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                  });
                } else {
                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "warning",
                    text: res.mensagem.descricao,
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                  });
                }
              }).catch((err) => {
                Swal.fire({
                  toast: true,
                  position: "top-end",
                  icon: "error",
                  text: err.mensagem.descricao,
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                });
              }).finally(() => {
                this.obter()
              });
          }
        });
      }
    });
  }

	formatarTooltipCanc(element: any): string {

		const data = element?.dataCanc
			? new Date(element.dataCanc).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelNomeCanc || 'Usuário desconhecido';
		const comentario = element?.justificativaCanc || 'Sem justificativa';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

  public finalizarMonitoramento(planoAcao: IPlanoAcaoModel) {

    Swal.fire({
      title: "Finalizar Monitoramento do Plano de Ação",
      text: "Tem certeza que deseja finalizar a implementação e monitoramento do Plano de Ação da Auditoria?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {

        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-component';
        dialogConfig.width = '45vw';
        dialogConfig.maxHeight = '85vh';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = false;
        dialogConfig.data = {
        }
        const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
        modal.afterClosed().subscribe(justificativa => {

          if (justificativa) {

            planoAcao.responsavelIdMonitoramentoFinMan = this.authService.usuario.id; 
            planoAcao.justificativaMonitoramentoFin = justificativa; 

            this.PlanoAcaoService.finalizarMonitoramentoManual(planoAcao)
              .then((res) => {
                if (res.sucesso) {
                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    text: res.mensagem.descricao,
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                  });
                } else {
                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "warning",
                    text: res.mensagem.descricao,
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                  });
                }
              }).catch((err) => {
                Swal.fire({
                  toast: true,
                  position: "top-end",
                  icon: "error",
                  text: err.mensagem.descricao,
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                });
              }).finally(() => {
                this.obter()
              });
          }
        });
      }
    });
  }

  public habilitarMonitoramento(planoAcao: IPlanoAcaoModel) {

    Swal.fire({
      title: "Habilitar Monitoramento do Plano de Ação",
      text: "Tem certeza que deseja habilitar a implementação e monitoramento do Plano de Ação da Auditoria?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {

        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-component';
        dialogConfig.width = '45vw';
        dialogConfig.maxHeight = '85vh';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = false;
        dialogConfig.data = {
        }
        const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
        modal.afterClosed().subscribe(justificativa => {

          if (justificativa) {

            planoAcao.responsavelIdMonitoramentoFinMan = this.authService.usuario.id; 
            planoAcao.justificativaMonitoramentoFin = justificativa; 

            this.PlanoAcaoService.habilitarMonitoramento(planoAcao)
              .then((res) => {
                if (res.sucesso) {
                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    text: res.mensagem.descricao,
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                  });
                } else {
                  Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "warning",
                    text: res.mensagem.descricao,
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                  });
                }
              }).catch((err) => {
                Swal.fire({
                  toast: true,
                  position: "top-end",
                  icon: "error",
                  text: err.mensagem.descricao,
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                });
              }).finally(() => {
                this.obter()
              });
          }
        });
      }
    });
  }

  formatarTooltipMonitoramentoFin(element: any): string {
    return element?.justificativaMonitoramentoFin
      ? element.justificativaMonitoramentoFin.replace(/\r\n/g, '\n')
      : '';
  }

  // Demanda 68742 linha 41 – Gerar nova versão (protótipo 4.5).
  public gerarVersao(planoAcao: IPlanoAcaoModel) {
    Swal.fire({
      title: 'Registrar versão do plano de ação',
      text: 'Deseja registrar a atual versão do plano de ação?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then((res) => {
      if (!res.isConfirmed) {
        return;
      }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-versao-descricao';
      dialogConfig.width = '45vw';
      dialogConfig.maxHeight = '85vh';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = false;
      dialogConfig.data = { titulo: 'Descrição da versão (máx. 200 caracteres)', maxLength: 200, rotulo: 'Descrição da versão*' };
      const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
      modal.afterClosed().subscribe((descricao: string) => {
        if (!descricao) {
          return;
        }
        if (descricao.length > 200) {
          Swal.fire({ toast: true, position: 'top-end', icon: 'warning', text: 'A descrição deve ter no máximo 200 caracteres.', showConfirmButton: false, timer: 5000, timerProgressBar: true });
          return;
        }
        this.PlanoAcaoService.gerarVersao(planoAcao.id, { descricao })
          .then((r) => {
            Swal.fire({ toast: true, position: 'top-end', icon: r.sucesso ? 'success' : 'warning', text: r.sucesso ? `Versão ${r.dados?.numero} gerada com sucesso.` : r.mensagem.descricao, showConfirmButton: false, timer: 5000, timerProgressBar: true });
          }).catch((err) => {
            Swal.fire({ toast: true, position: 'top-end', icon: 'error', text: err?.mensagem?.descricao || 'Erro ao gerar versão.', showConfirmButton: false, timer: 5000, timerProgressBar: true });
          }).finally(() => {
            this.obter();
          });
      });
    });
  }

  // Demanda 68742 linha 41 – Histórico de versões (protótipos 4.6/4.7).
  public historicoVersoes(planoAcao: IPlanoAcaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-plano-acao-versoes';
    dialogConfig.width = '70vw';
    dialogConfig.maxHeight = '140vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { titulo: 'Histórico de versões', id: planoAcao.id };
    const modal = this.matDialog.open(PlanoAcaoMonitorVersoesComponent, dialogConfig);
    modal.afterClosed().subscribe(() => {
      this.obter();
    });
  }

}
